export class TrainRequest {
  origin: string;
  destination: string;
  departure: string;
  return?: string;
  annotations: string;
  userUuid?: string;
  oneWay: boolean;
}
